<div class="highlighted-container container">
    <div class="row">
        <div class="highlighted">  
            <div class="region region-highlighted">
                <h1 class="page-header">
                    <span>{{ 'REQUEST_LIST_HEADING' | translate }}</span>
                </h1>
            </div>
        </div>
    </div>
</div>

<div class="main-container container">
    <div class="row">
        <section class="col-sm-1"></section>
        <section class="col-sm-7">
            <div class="region region-content">
                <p style="font-weight:bold;"> {{ 'REQUEST_LIST_TITLE' | translate }}</p>
                <div><button type="button" class="btn btn-secondary btn-expand-list" (click)="handleRequestPaymentDateChange()">{{ "HEADER_REQUESTS_PAYMENT_DUE_DATE" | translate }}</button></div>
                <div><button type="button" class="btn btn-secondary btn-expand-list" (click)="handleRequestBankAccountChange()">{{ "HEADER_REQUESTS_BANK_ACCOUNT_CHANGE" | translate }}</button></div>
                <div><button type="button" class="btn btn-secondary btn-expand-list" (click)="handleRequestNameChange()">{{ "HEADER_REQUESTS_NAME_CHANGE" | translate }}</button></div>
                <div><button type="button" class="btn btn-secondary btn-expand-list" (click)="handleRequestAddressChange()">{{ "HEADER_REQUESTS_ADDRESS_CHANGE" | translate }}</button></div>
                <div><button type="button" class="btn btn-secondary btn-expand-list" (click)="handleRequestPhoneChange()">{{ "HEADER_REQUESTS_PHONE_CHANGE" | translate }}</button></div>
                <div><button type="button" class="btn btn-secondary btn-expand-list" (click)="handleRequestEmailChange()">{{ "HEADER_REQUESTS_EMAIL_CHANGE" | translate }}</button></div>
                <div><button type="button" class="btn btn-secondary btn-expand-list" (click)="handleRequestLeaseTransfer()">{{ "HEADER_REQUESTS_LEASE_TRANSFER" | translate }}</button></div>
                <div><button type="button" class="btn btn-secondary btn-expand-list" (click)="handleRequestOtherChange()">{{ "HEADER_REQUESTS_OTHER_CHANGE" | translate }}</button></div>
            </div>
        </section>
        <section class="col-sm-3">
            <div class="region region-sidebar-second">
                <div class="field field--name-body field--type-text-with-summary field--label-hidden field--item">
                    <p style="font-weight:bold;"> {{ 'REQUEST_LIST_SIDE_TITLE' | translate }}</p>
                    <div><button type="button" class="btn btn-secondary btn-expand-list" (click)="submitInsuranceInfo()" style="white-space: normal; word-wrap: break-word;">{{ "REQUEST_LIST_SIDE_SUBMIT_INSURANCE" | translate }}</button></div>
                    <div><button type="button" class="btn btn-secondary btn-expand-list" [routerLink]="['/customer-intent']" style="white-space: normal; word-wrap: break-word;">{{ "REQUEST_LIST_SIDE_SUBMIT_INTENT" | translate }}</button></div>
                </div>                 
            </div>
        </section>
         <section class="col-sm-1"></section>
    </div>
</div>